/* MXDVS menu drawer: the outline skull in the centre of the radar (04.10.2026). Phones and tablets only.
   Adds the skull to the menu sheet and keeps its light in step with the radar sweep: the skull's light turns
   with the same animation (mxm-spin, 7s), started at the same moment as the radar (#menu-drawer::after).
   05.10.2026 (D2, D3): the skull and the crosshair sit in one wrapper, .mxm-fx, so they can blur together with
   the radar while a sub menu is open.
   06.10.2026 (light version): videos behind the open menu pause, and play again when it closes, so the
   blurs behind the menu do not have to be redrawn for every video frame.
   Styles: assets/mxdvs-menu-skull.css. Loaded by sections/mxdvs-menu-terminal.liquid. */
(function () {
  if (window.__mxdvsMenuSkull) return;
  window.__mxdvsMenuSkull = true;

  function radarSpin(drawer) {
    if (!drawer.getAnimations) return null;
    var list = drawer.getAnimations({ subtree: true });
    for (var i = 0; i < list.length; i++) {
      var a = list[i];
      if (a.animationName === 'mxm-spin' && a.effect && a.effect.pseudoElement === '::after' && a.effect.target === drawer) return a;
    }
    return null;
  }

  function sync(drawer, skull) {
    var radar = radarSpin(drawer);
    var light = skull.firstChild;
    if (!radar || !light || !light.getAnimations) return;
    var own = light.getAnimations()[0];
    if (own && radar.startTime !== null) own.startTime = radar.startTime;
  }

  /* Pause playing videos while the menu is open; only the ones paused here play again on close */
  function pauseVideos(open) {
    var vids = document.querySelectorAll('video');
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      if (open) {
        if (!v.paused) { v.dataset.mxmPaused = '1'; v.pause(); }
      } else if (v.dataset.mxmPaused) {
        delete v.dataset.mxmPaused;
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () {});
      }
    }
  }

  function init() {
    var drawer = document.getElementById('menu-drawer');
    if (!drawer) return;
    /* a skull from before 05.10.2026 (theme editor reload) goes, the wrapper replaces it */
    var old = drawer.querySelector(':scope > .mxm-skull');
    if (old) old.remove();
    var fx = drawer.querySelector(':scope > .mxm-fx');
    if (!fx) {
      fx = document.createElement('i');
      fx.className = 'mxm-fx keep-empty';
      fx.setAttribute('aria-hidden', 'true');
      fx.innerHTML = '<i class="mxm-cross keep-empty"></i><i class="mxm-skull keep-empty"><i></i></i>';
      drawer.insertBefore(fx, drawer.firstChild);
    }
    var skull = fx.querySelector('.mxm-skull');
    sync(drawer, skull);
    /* the radar can restart (opening the menu, theme editor); line the light up again each time the menu opens */
    var container = document.getElementById('Details-menu-drawer-container');
    if (container && !container.dataset.mxmSkull) {
      container.dataset.mxmSkull = '1';
      var wasOpen = false;
      new MutationObserver(function () {
        var s = drawer.querySelector(':scope > .mxm-fx > .mxm-skull');
        if (s) sync(drawer, s);
        var open = container.classList.contains('menu-opening');
        if (open !== wasOpen) { wasOpen = open; pauseVideos(open); }
      }).observe(container, { attributes: true, attributeFilter: ['class', 'open'] });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
